import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { SavedSearchesPage } from "./-components/chats-page/saved-searches-page";

export const Route = createFileRoute("/_dashboard/$datasetSlug/(chats)/chats_/$conversationId/searches/$searchId")({
  component: SavedSearchRoute,
});

function SavedSearchRoute() {
  const { datasetSlug, conversationId, searchId } = Route.useParams();
  const navigate = useNavigate({ from: Route.fullPath });

  return (
    <SavedSearchesPage
      conversationId={conversationId}
      selectedSearchId={searchId}
      onBack={() => {
        void navigate({
          to: "/$datasetSlug/chats/$conversationId",
          params: { datasetSlug, conversationId },
        });
      }}
      onSelectSearch={(nextSearchId) => {
        void navigate({
          to: "/$datasetSlug/chats/$conversationId/searches/$searchId",
          params: { datasetSlug, conversationId, searchId: nextSearchId },
        });
      }}
      onMentionRecords={(records) => {
        void navigate({
          to: "/$datasetSlug/chats/$conversationId",
          params: { datasetSlug, conversationId },
          state: (previous) => ({
            ...previous,
            pendingRecordMentions: {
              requestId: crypto.randomUUID(),
              conversationId,
              records: records.map((record) => ({
                source:
                  record.source === "custom" && record.customModelId ? `CE_${record.customModelId}` : record.source,
                id: record.id,
                label: record.title || record.id,
              })),
            },
          }),
        });
      }}
    />
  );
}
